export default __webpack_public_path__ + "static/media/mail-icon-on.0649bfcd.svg";